'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeImageGalleryActiveIndex = exports.getImageGalleryActiveImage = exports.CHANGE_IMAGE_GALLERY_ACTIVE_INDEX = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _reselect = require('reselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CHANGE_IMAGE_GALLERY_ACTIVE_INDEX = exports.CHANGE_IMAGE_GALLERY_ACTIVE_INDEX = 'CHANGE_IMAGE_GALLERY_ACTIVE_INDEX';

// reducer
var DEFAULT_STATE = {};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CHANGE_IMAGE_GALLERY_ACTIVE_INDEX:
            return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.payload.itemId, action.payload.newIndex));
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.imageGalleryActiveImage;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var getImageGalleryActiveImage = exports.getImageGalleryActiveImage = (0, _reselect.createSelector)([stateSelector, idSelector], function (state, id) {
    return state[id] || 0;
});

/* ACTION CREATORS */
var changeImageGalleryActiveIndex = exports.changeImageGalleryActiveIndex = function changeImageGalleryActiveIndex(itemId, newIndex) {
    return {
        payload: { itemId: itemId, newIndex: newIndex },
        type: CHANGE_IMAGE_GALLERY_ACTIVE_INDEX
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/imageGalleryActiveImage.js
// module id = lp2g
// module chunks = 60